import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "common/config";
import Upload from "../upload-page/Upload";
import "./DataClassificationHub.scss";
import HeaderNew from "common/components/custom/header-new/HeaderNew";
import HubHeader from "common/components/custom/hub-header/HubHeader";

const DataClassificationHub: React.FC = () => {
  const navigate = useNavigate();
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [currentStep, setCurrentStep] = useState<"upload" | "processing">(
    "upload"
  );

  const handleFilesUploaded = (files: File[]) => {
    setUploadedFiles(files);
    setCurrentStep("processing");

    setTimeout(() => {
      const mockBatchGuid = `batch-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      // Navigate to results page with batchGuid in URL
      navigate(
        MainRoutes.DATA_CLASSIFICATION_RESULTS.replace(
          ":batchGuid",
          mockBatchGuid
        ),
        {
          state: {
            totalFiles: files.length,
            classificationName: `Upload_${new Date()
              .toLocaleDateString()
              .replace(/\//g, "-")}`
          },
          replace: true
        }
      );
    }, 1500);
  };

  const handleStartOver = () => {
    setUploadedFiles([]);
    setCurrentStep("upload");
  };

  return (
    <>
      <HeaderNew showSearch={false} />
      <div className="data-classification-hub">
        <HubHeader
          title="Classification Hub"
          description="Classify documents and validate category"
          showBackButton={true}
          backRoute={MainRoutes.DATA_CLASSIFICATION_HISTORY}
        />

        <div className="hub-content">
          {currentStep === "upload" && (
            <Upload onFilesUploaded={handleFilesUploaded} />
          )}

          {currentStep === "processing" && (
            <div className="processing-view">
              <div className="processing-content">
                <div className="processing-icon">
                  <div className="spinner"></div>
                </div>
                <h2>Processing Your Documents</h2>
                <p>Analyzing and classifying {uploadedFiles.length} files...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DataClassificationHub;
